// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__3KINz","label":"Completed_label__39vPf"};